import {
  atomFamily,
  selectorFamily
} from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchState = async (businessId) => {
  const response = await vodaLend.getDirectorDetails(businessId);
  return response.data;
};

export const updateDirectorDetails = async (inputData) => {
  const response = await vodaLend.putDirectorDetails(inputData);
  return response.data;
};

const directorDetailsDefault = selectorFamily({
  key: 'directorDetailsDefault',
  get: (businessId) => async () => {
    return await fetchState(businessId);
  }
});

export const directorDetailsState = atomFamily({
  key: 'directorDetailsState',
  default: (businessId) => directorDetailsDefault(businessId)
});

export const directorDetailsSubmit = selectorFamily({
  key: 'directorDetailsSubmit',
  get: (businessId) => ({ get }) => {
    return get(directorDetailsState(businessId));
  },
  set: (businessId) => ({ get, set }, inputData) => {

    const cur = get(directorDetailsState(businessId)) || {};

    if (inputData.error) {
      const data = Object.fromEntries(
        Object
          .entries({ ...cur, ...inputData })
          .filter(([k, _]) => k !== 'error' && k !== 'traceId')
      );
      set(directorDetailsState(businessId), data);
      return;
    }
    set(directorDetailsState(businessId), updateDirectorDetails({
      ...cur,
      ...inputData
    }));
  }
});
